export default "__VITE_ASSET__9df947ce__"